import { render, staticRenderFns } from "./ViewInformationOnHover.vue?vue&type=template&id=842a6f84&scoped=true"
import script from "./ViewInformationOnHover.vue?vue&type=script&lang=js"
export * from "./ViewInformationOnHover.vue?vue&type=script&lang=js"
import style0 from "./ViewInformationOnHover.vue?vue&type=style&index=0&id=842a6f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842a6f84",
  null
  
)

export default component.exports